import { render } from "./CoursesListView.vue?vue&type=template&id=3ecc3c66&scoped=true&ts=true"
import script from "./CoursesListView.vue?vue&type=script&lang=ts"
export * from "./CoursesListView.vue?vue&type=script&lang=ts"

import "./CoursesListView.vue?vue&type=style&index=0&id=3ecc3c66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecc3c66"]])

export default __exports__